<template>
  <f7-page
    :page-content="true"
  >
    <f7-navbar
      class="bg-madai"
    >
      <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      <f7-nav-title class="text-white">Información de envío</f7-nav-title>
    </f7-navbar>

    <div v-if="storage.guardarFacturacion" class="text-center fs-16 alert alert-danger">Hay cambios sin guardar...</div>

    <f7-list no-hairlines-md>
      <f7-list-input
        class="required"
        label="Nombre completo"
        type="text"
        placeholder="Escribe el nombre completo"
        :value="storage.usuario.facturacion.nombre"
        @input="storage.usuario.facturacion.nombre = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Dirección línea 1"
        type="text"
        placeholder="Escribe tu dirección"
        :value="storage.usuario.facturacion.direccion1"
        @input="storage.usuario.facturacion.direccion1 = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        label="Dirección línea 2"
        type="text"
        placeholder="Escribe tu dirección"
        :value="storage.usuario.facturacion.direccion2"
        @input="storage.usuario.facturacion.direccion2 = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Estado"
        type="text"
        placeholder="Escribe el estado"
        :value="storage.usuario.facturacion.estado"
        @input="storage.usuario.facturacion.estado = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Ciudad / Municipio"
        type="text"
        placeholder="Escribe la ciudad / estado"
        :value="storage.usuario.facturacion.ciudad"
        @input="storage.usuario.facturacion.ciudad = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Código Postal"
        type="text"
        placeholder="Escribe el código postal"
        :value="storage.usuario.facturacion.cp"
        @input="storage.usuario.facturacion.cp = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Correo"
        type="email"
        placeholder="Escribe el correo"
        :value="storage.usuario.facturacion.email"
        @input="storage.usuario.facturacion.email = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Teléfono"
        type="text"
        placeholder="Escribe el teléfono"
        :value="storage.usuario.facturacion.telefono"
        @input="storage.usuario.facturacion.telefono = $event.target.value"
      ></f7-list-input>

      <f7-list-item>
        <f7-button class="margin-auto" fill @click="actualizar()" :disabled="
          storage.usuario.facturacion.nombre === '' ||
          storage.usuario.facturacion.direccion1 === '' ||
          storage.usuario.facturacion.estado === '' ||
          storage.usuario.facturacion.ciudad === '' ||
          storage.usuario.facturacion.cp === '' ||
          storage.usuario.facturacion.email === '' ||
          storage.usuario.facturacion.telefono === ''
        ">
          Guardar
        </f7-button>
      </f7-list-item>
    </f7-list>

    <navbar-bottom />
  </f7-page>
</template>

<script>
import navbarBottom from '@/components/navbar-bottom'

export default {
  components: {
    navbarBottom
  },
  watch: {
    'storage.usuario.facturacion': {
      deep: true,
      handler () {
        this.storage.guardarFacturacion = true
      }
    }
  },
  methods: {
    async actualizar () {
      try {
        await this.$api.facturacion.guardar(this.storage.usuario.facturacion)
        this.$f7.dialog.alert('Información actualizada.', `MADAI`, () => {})
        this.storage.guardarFacturacion = false
      } catch (err) {
        this.$f7.dialog.alert('No se pudo actualizar la información.', `MADAI`, () => {})
      }
    }
  }
}
</script>
